import { setObject, getObject, removeObject } from 'utils/localStorage';
import { ContentType, autoSuggestHistoryKey, autosuggestVersion } from 'actions/AutosuggestActions/Utils';
import { getNavigationUrlFromAction } from './V4ResponseParser';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { LoginType } from '@rome/response/enums/LoginType';
import get from 'lodash/get';
let searchBrowseRequestHistory = { FLIPKART: [], GROCERY: [] };
let suggestionHistory = { FLIPKART: [], GROCERY: [] };
const HISTORY_LENGTH = 5;
const history_icon = 'https://rukminim1.flixcart.com/www/{@width}/{@height}/promos/19/07/2018/321e89f8-9ffa-47a7-a9d4-731da9bde6c4.png?q={@quality}';
/**
 * Read the autosuggest history from local storage and in componentDidmount of Search and maintain
 * the object in memory for entire session
 */
export function initalizeHistory() {
    suggestionHistory = getObject(autoSuggestHistoryKey) || {};
    for (let marketplace in suggestionHistory) {
        if (suggestionHistory.hasOwnProperty(marketplace) && suggestionHistory[marketplace]) {
            const suggestion = suggestionHistory[marketplace];
            const tempSearchBrowseRequestHistory = [];
            suggestion.forEach(item => {
                tempSearchBrowseRequestHistory.push({
                    marketPlaceId: item.marketplace,
                    uri: item.value.navigationUrl,
                    timestamp: item.userTimeStamp
                });
            });
            searchBrowseRequestHistory[marketplace] = tempSearchBrowseRequestHistory;
        }
    }
}
/**
 *
 * @param marketplace
 * @param item
 * Save history item in local storage and update the local copy to save a local storage operation
 * last searched item store at 1st position with modified tracking parameter and
 * update the tracking parmeter in the remaining items
 * maintain the history saperately for all the marketplaces
 * V4 api request need the user browse history to provide better prediction so along with the
 * searchBrowse history maintain the searchBrowseRequestHistoryData array also.
 *
 */
export function saveAndUpdateHistory(marketplace, item) {
    let data = [];
    let searchBrowseRequestHistoryData = [];
    const tracking = item.tracking || {};
    let positionCounter = 0;
    tracking.position = (++positionCounter).toString();
    const newSuggestion = Object.assign(Object.assign({}, item), { value: Object.assign(Object.assign({}, item.value), { contentType: ContentType.HISTORY, imageUrl: history_icon, navigationUrl: getNavigationUrlFromAction(ContentType.HISTORY, item.action, tracking) }) });
    const type = newSuggestion.value.type === 'QUERY_STORE' ? 'QueryStore' : 'Query';
    if (newSuggestion.action) {
        Object.assign(newSuggestion.action, Object.assign(Object.assign({}, item.action), { tracking: {
                otracker: `AS_${type}_HistoryAutoSuggest_{POSITION}_0`,
                otracker1: `AS_${type}_HistoryAutoSuggest_{POSITION}_0`
            } }));
    }
    data.push(newSuggestion);
    searchBrowseRequestHistoryData.push({
        uri: item.value.navigationUrl,
        marketPlaceId: item.marketplace,
        timestamp: Date.now()
    });
    const suggetionHistoryData = suggestionHistory[marketplace] || [];
    suggetionHistoryData.slice(0, HISTORY_LENGTH - 1).forEach(historyItem => {
        if (item.value.title !== historyItem.value.title) {
            positionCounter += 1;
            const tracking = Object.assign({}, get(historyItem, ['action', 'tracking']), get(historyItem, ['tracking']), { position: positionCounter.toString() });
            historyItem.value.navigationUrl = getNavigationUrlFromAction(ContentType.HISTORY, historyItem.action, tracking);
            data.push(historyItem);
            searchBrowseRequestHistoryData.push({
                uri: historyItem.value.navigationUrl,
                marketPlaceId: item.marketplace,
                timestamp: Date.now()
            });
        }
    });
    suggestionHistory[marketplace] = data;
    searchBrowseRequestHistory[marketplace] = searchBrowseRequestHistoryData;
    setTimeout(() => {
        setObject(`${autoSuggestHistoryKey}`, suggestionHistory);
    }, 0);
}
export function getSearchHistory(marketplace) {
    const historyData = get(suggestionHistory, marketplace) || [];
    return historyData.slice(0, HISTORY_LENGTH);
}
export function getSearchBrowseRequestHistory() {
    const emptyArray = {};
    return searchBrowseRequestHistory ? searchBrowseRequestHistory : emptyArray;
}
export function savePlainQueryInHistory(query, url, marketplace) {
    const suggestionValue = {
        title: query,
        query,
        template: WidgetTypeV4.AUTOSUGGEST_QUERY_WIDGET,
        backfill: query,
        contentType: 'QUERY',
        navigationUrl: url,
        type: 'QUERY'
    };
    const action = {
        url,
        loginType: LoginType.LOGIN_NOT_REQUIRED,
        type: 'mulitiwidget',
        params: { marketplace },
        tracking: {}
    };
    const suggestion = {
        value: suggestionValue,
        action,
        marketplace,
        userTimeStamp: Date.now(),
        version: autosuggestVersion.V4
    };
    saveAndUpdateHistory(marketplace, suggestion);
}
export function deleteHistory() {
    removeObject(autoSuggestHistoryKey);
}
